import { useContext } from 'react'

import { HeartIcon } from 'reactGarden/HeartIcon'

import { WishlistContext } from 'reactSite/Wishlist/context'

const WishListButton = ({ isActive, product }) => {
  const wishlistValues = useContext(WishlistContext)

  const {
    onPressHeart,
    isOnWishlist
  } = wishlistValues

  const data = {
    inWishList: isActive,
    id: product.id,
    product
  }

  const wishlistAction = (event) => {
    event.stopPropagation()

    onPressHeart(data, 'products')
  }

  return (
    <button aria-label="Adicionar a Lista de Favoritos" className="wishlist-button" onClick={ wishlistAction }>
      <HeartIcon isActive={ isOnWishlist(product.id) } />
    </button>
  )
}

export default WishListButton
